import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { Component } from '@angular/compiler/src/core';
import { Observable, Subject } from 'rxjs';
import { UnderWrittenComponent } from 'src/app/components/general/under-written/under-written.component';
const modalOptions: NgbModalOptions = {
	backdrop: true,
	keyboard: true,
	windowClass: '',
};

@Injectable()
export class InformationModalService {
	isOpen: boolean;
	modalRef: NgbModalRef;
	windowClass: any;
	componentType: Component;
	openedTooltipSubject: Subject<any> = new Subject<any>();
	openedTooltip$: Observable<any> = this.openedTooltipSubject.asObservable();

	constructor(private modalService: NgbModal) {}

	async open({ data: data, windowClass: windowClass, componentType: componentType }) {
		modalOptions.windowClass = windowClass;
		const modalRef: NgbModalRef = this.modalService.open(componentType, modalOptions);
		this.modalRef = modalRef;
		this.isOpen = true;
		modalRef.componentInstance.modal = { data };
		modalRef.componentInstance.closeModal = this.close;
		modalRef.componentInstance.modalRef = this.modalRef;
		await modalRef.result;
		this.isOpen = false;
	}

	isModelOpen() {
		return this.isOpen;
	}

	async close() {
		if (this.modalRef) {
			this.modalRef.close();
		}
	}
}
